import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
import config from '@/config';
import { ChatType, IMAGE_CDN_PREFIX, SIDEBAR_TAB_KEYS } from '@/helper/const';
import { currencyCode, getCurrencySymbol } from '@/helper/currency';
import { computed, onMounted, ref, watch } from 'vue';
import { appState } from '../../composable/appState';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ChatWidgetPreview',
    props: {
        tabType: {
            type: String,
            default: '',
        },
    },
    setup(__props) {
        const props = __props;
        const chatWidgetRef = ref(null);
        onMounted(() => {
            const themejs = document.createElement('script');
            themejs.setAttribute('src', ` ${config.DEPLOYMENT_URL}loader.js`);
            document.head.appendChild(themejs);
            localStorage.setItem('lead-connecter-text-widget-prompt-dismissed', JSON.stringify({}));
        });
        watch(() => chatWidgetRef.value, () => {
            try {
                if (chatWidgetRef.value && props.tabType === SIDEBAR_TAB_KEYS.WIDGET)
                    chatWidgetRef.value.scrollIntoView(false);
            }
            catch (e) {
                console.error(e);
            }
        });
        let settingsData = appState.chatWidgetSettingsData;
        watch(() => settingsData, newValue => {
            settingsData = newValue;
        }, { deep: true });
        const themeProp = computed(() => {
            return (settingsData === null || settingsData === void 0 ? void 0 : settingsData.theme) ? JSON.stringify(settingsData === null || settingsData === void 0 ? void 0 : settingsData.theme) : null;
        });
        const businessOfficeHoursProp = computed(() => {
            var _a, _b;
            return ((_a = settingsData === null || settingsData === void 0 ? void 0 : settingsData.advanceSettings) === null || _a === void 0 ? void 0 : _a.businessOfficeHours)
                ? JSON.stringify((_b = settingsData === null || settingsData === void 0 ? void 0 : settingsData.advanceSettings) === null || _b === void 0 ? void 0 : _b.businessOfficeHours)
                : null;
        });
        const contactFormOptionsProp = computed(() => {
            var _a, _b;
            return ((_a = settingsData === null || settingsData === void 0 ? void 0 : settingsData.advanceSettings) === null || _a === void 0 ? void 0 : _a.contactFormOptions)
                ? JSON.stringify((_b = settingsData === null || settingsData === void 0 ? void 0 : settingsData.advanceSettings) === null || _b === void 0 ? void 0 : _b.contactFormOptions)
                : null;
        });
        const chatWidgetLocale = computed(() => {
            if (settingsData.locale === 'location') {
                return appState.locale;
            }
            else
                return settingsData.locale;
        });
        const chatWidgetInlineHeight = computed(() => {
            var _a, _b;
            const baseHeight = Number(((_b = (_a = settingsData.dimensions) === null || _a === void 0 ? void 0 : _a.sizes) === null || _b === void 0 ? void 0 : _b.height) || 640);
            return baseHeight + 100;
        });
        const promptAvatar = computed(() => {
            if (settingsData.isPromptAvatarImageOptimize &&
                settingsData.promptAvatar &&
                !settingsData.promptAvatar.includes('/chat-widget/assets/defaultAvatar.png')) {
                return `${IMAGE_CDN_PREFIX}${settingsData.promptAvatar}`;
            }
            return settingsData.promptAvatar;
        });
        return (_ctx, _cache) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0;
            const _component_chat_widget = _resolveComponent("chat-widget");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(_component_chat_widget, {
                    ref_key: "chatWidgetRef",
                    ref: chatWidgetRef,
                    "allow-avatar-image": _unref(settingsData).allowAvatarImage,
                    "ack-icon": (_a = _unref(settingsData).acknowledgementDetails) === null || _a === void 0 ? void 0 : _a.icon,
                    "ack-placeholder-color": (_b = _unref(settingsData).acknowledgementDetails) === null || _b === void 0 ? void 0 : _b.placeholderColor,
                    theme: _unref(themeProp),
                    "primary-color": _unref(settingsData).widgetPrimaryColor,
                    position: (_c = _unref(settingsData).dimensions) === null || _c === void 0 ? void 0 : _c.position,
                    "chat-icon": _unref(settingsData).chatIcon,
                    "inline-prompt-mode": props.tabType === _unref(SIDEBAR_TAB_KEYS).WIDGET ? true : false,
                    "inline-mode": props.tabType === _unref(SIDEBAR_TAB_KEYS).WIDGET ? false : true,
                    "location-id": _unref(appState).locationId,
                    heading: _unref(settingsData).heading,
                    "sub-heading": _unref(settingsData).subHeading,
                    "prompt-msg": _unref(settingsData).promptMsg,
                    "prompt-type": _unref(settingsData).promptType,
                    "legal-msg": _unref(settingsData).legalMsg,
                    "contact-form-options": _unref(settingsData).chatType !== _unref(ChatType).LIVE_CHAT && _unref(appState).levelUpCompany
                        ? _unref(contactFormOptionsProp)
                        : null,
                    "show-prompt": String(_unref(settingsData).showPrompt),
                    "use-email-field": _unref(settingsData).useEmailField,
                    "enable-revisit-message": _unref(settingsData).showPrompt && String(_unref(settingsData).enableRevisitMessage),
                    "revisit-prompt-msg": _unref(settingsData).enableRevisitMessage && String(_unref(settingsData).revisitPromptMsg),
                    "prompt-avatar-alt-text": _unref(settingsData).promptAvatarAltText,
                    "prompt-avatar": _unref(promptAvatar) && String(_unref(promptAvatar)),
                    "agency-name": _unref(settingsData).showAgencyBranding && _unref(settingsData).agencyName
                        ? String(_unref(settingsData).agencyName)
                        : '',
                    "branding-title": _unref(settingsData).showAgencyBranding &&
                        ((_e = (_d = _unref(settingsData)) === null || _d === void 0 ? void 0 : _d.advanceSettings) === null || _e === void 0 ? void 0 : _e.brandingTitle)
                        ? String((_g = (_f = _unref(settingsData)) === null || _f === void 0 ? void 0 : _f.advanceSettings) === null || _g === void 0 ? void 0 : _g.brandingTitle)
                        : '',
                    "agency-website": _unref(settingsData).showAgencyBranding && _unref(settingsData).agencyWebsite
                        ? String(_unref(settingsData).agencyWebsite)
                        : '',
                    "redirect-action": (_k = (_j = (_h = _unref(settingsData)) === null || _h === void 0 ? void 0 : _h.advanceSettings) === null || _j === void 0 ? void 0 : _j.redirect) === null || _k === void 0 ? void 0 : _k.redirectAction,
                    "redirect-text": (_o = (_m = (_l = _unref(settingsData)) === null || _l === void 0 ? void 0 : _l.advanceSettings) === null || _m === void 0 ? void 0 : _m.redirect) === null || _o === void 0 ? void 0 : _o.redirectText,
                    "redirect-website": (_r = (_q = (_p = _unref(settingsData)) === null || _p === void 0 ? void 0 : _p.advanceSettings) === null || _q === void 0 ? void 0 : _q.redirect) === null || _r === void 0 ? void 0 : _r.redirectWebsite,
                    "business-office-hours": _unref(appState).levelUpCompany ? _unref(businessOfficeHoursProp) : null,
                    "send-label": _unref(settingsData).sendActionText,
                    locale: _unref(chatWidgetLocale),
                    "location-country-code": _unref(appState).levelUpCompany ? _unref(settingsData).locationCountryCode : null,
                    "currency-symbol": _unref(appState).levelUpCompany
                        ? _unref(getCurrencySymbol)(_unref(currencyCode)[_unref(settingsData).locationCountryCode])
                        : null,
                    "show-live-chat-welcome-msg": _unref(settingsData).showLiveChatWelcomeMsg,
                    "show-consent-checkbox": _unref(settingsData).showConsentCheckbox,
                    "enable-contact-form": (_t = (_s = _unref(settingsData)) === null || _s === void 0 ? void 0 : _s.advanceSettings) === null || _t === void 0 ? void 0 : _t.enableContactForm,
                    "default-consent-check": (_v = (_u = _unref(settingsData)) === null || _u === void 0 ? void 0 : _u.advanceSettings) === null || _v === void 0 ? void 0 : _v.defaultConsentCheck,
                    "wa-number": _unref(settingsData).waNumber,
                    "chat-type": _unref(settingsData).chatType,
                    height: (_x = (_w = _unref(settingsData).dimensions) === null || _w === void 0 ? void 0 : _w.sizes) === null || _x === void 0 ? void 0 : _x.height,
                    width: (_z = (_y = _unref(settingsData).dimensions) === null || _y === void 0 ? void 0 : _y.sizes) === null || _z === void 0 ? void 0 : _z.width,
                    "inline-success-mode": props.tabType === _unref(SIDEBAR_TAB_KEYS).MESSAGING ? true : false,
                    "inline-live-chat-success-mode": (_0 = _unref(settingsData).chatType === _unref(ChatType).LIVE_CHAT) !== null && _0 !== void 0 ? _0 : true,
                    "live-chat-feedback-msg": props.tabType === _unref(SIDEBAR_TAB_KEYS).MESSAGING ||
                        _unref(SIDEBAR_TAB_KEYS).CHAT_WINDOW
                        ? _unref(settingsData).liveChatFeedbackMsg
                        : null,
                    "live-chat-feedback-note": props.tabType === _unref(SIDEBAR_TAB_KEYS).MESSAGING ||
                        _unref(SIDEBAR_TAB_KEYS).CHAT_WINDOW
                        ? _unref(settingsData).liveChatFeedbackNote
                        : null,
                    "live-chat-intro-msg": props.tabType === _unref(SIDEBAR_TAB_KEYS).MESSAGING ||
                        _unref(SIDEBAR_TAB_KEYS).CHAT_WINDOW
                        ? _unref(settingsData).liveChatIntroMsg
                        : null,
                    "live-chat-ack-msg": props.tabType === _unref(SIDEBAR_TAB_KEYS).MESSAGING ||
                        _unref(SIDEBAR_TAB_KEYS).CHAT_WINDOW
                        ? _unref(settingsData).liveChatAckMsg
                        : null,
                    "live-chat-end-msg": props.tabType === _unref(SIDEBAR_TAB_KEYS).MESSAGING ||
                        _unref(SIDEBAR_TAB_KEYS).CHAT_WINDOW
                        ? _unref(settingsData).liveChatEndedMsg
                        : null,
                    "live-chat-user-inactive-msg": props.tabType === _unref(SIDEBAR_TAB_KEYS).MESSAGING ||
                        _unref(SIDEBAR_TAB_KEYS).CHAT_WINDOW
                        ? _unref(settingsData).liveChatUserInactiveMsg
                        : null,
                    "live-chat-visitor-inactive-msg": props.tabType === _unref(SIDEBAR_TAB_KEYS).MESSAGING ||
                        _unref(SIDEBAR_TAB_KEYS).CHAT_WINDOW
                        ? _unref(settingsData).liveChatVisitorInactiveMsg
                        : null,
                    "support-contact": props.tabType === _unref(SIDEBAR_TAB_KEYS).MESSAGING ||
                        _unref(SIDEBAR_TAB_KEYS).CHAT_WINDOW
                        ? _unref(settingsData).supportContact
                        : null,
                    "success-msg": props.tabType === _unref(SIDEBAR_TAB_KEYS).MESSAGING ||
                        _unref(SIDEBAR_TAB_KEYS).CHAT_WINDOW
                        ? _unref(settingsData).successMsg
                        : null,
                    "thank-you-msg": props.tabType === _unref(SIDEBAR_TAB_KEYS).MESSAGING ||
                        _unref(SIDEBAR_TAB_KEYS).CHAT_WINDOW
                        ? _unref(settingsData).thankYouMsg
                        : null,
                    "inline-live-chat-mode": props.tabType === _unref(SIDEBAR_TAB_KEYS).CHAT_WINDOW &&
                        _unref(settingsData).chatType === _unref(ChatType).LIVE_CHAT
                        ? true
                        : false,
                    "builder-preview-version": "v2"
                }, null, 8 /* PROPS */, ["allow-avatar-image", "ack-icon", "ack-placeholder-color", "theme", "primary-color", "position", "chat-icon", "inline-prompt-mode", "inline-mode", "location-id", "heading", "sub-heading", "prompt-msg", "prompt-type", "legal-msg", "contact-form-options", "show-prompt", "use-email-field", "enable-revisit-message", "revisit-prompt-msg", "prompt-avatar-alt-text", "prompt-avatar", "agency-name", "branding-title", "agency-website", "redirect-action", "redirect-text", "redirect-website", "business-office-hours", "send-label", "locale", "location-country-code", "currency-symbol", "show-live-chat-welcome-msg", "show-consent-checkbox", "enable-contact-form", "default-consent-check", "wa-number", "chat-type", "height", "width", "inline-success-mode", "inline-live-chat-success-mode", "live-chat-feedback-msg", "live-chat-feedback-note", "live-chat-intro-msg", "live-chat-ack-msg", "live-chat-end-msg", "live-chat-user-inactive-msg", "live-chat-visitor-inactive-msg", "support-contact", "success-msg", "thank-you-msg", "inline-live-chat-mode"]),
                (_openBlock(), _createBlock(_resolveDynamicComponent('style'), null, {
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(`.chat-widget-builder-preview chat-widget { display: block; height:calc(100% - 20px); min-height: ${_unref(chatWidgetInlineHeight)}px; position: absolute; right: 0; width: calc(100vw - 420px)}`), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                }))
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
